import React, { memo } from 'react';
import {
  array, func, string, bool, object,
} from 'prop-types';
import classNames from 'classnames';
import find from 'lodash/find';
import Grid from '@active/react-ui/Grid';
import GridItem from '@active/react-ui/GridItem';
import Locale from '@active/react-utils/i18n/Locale';
import { handleKeyboardEvent } from '../../../shared/utils/commonUtils';
import OrderDetailContent from '../OrderDetailContent';

const OrderReview = ({
  showOrderReviewSection,
  orderReviewActionText,
  orderReviewDescription,
  orderReviewHandleableConfig,
  orderReviewModel,
  orderReviewActionCallback,
  handleOrderReviewCallback,
  trackingCallback,
  orderInfo,
}) => {
  if (!showOrderReviewSection) {
    return null;
  }

  const handleSubtitleClicked = () => {
    orderReviewActionCallback({ checkoutOrderIdentifier: orderInfo.identifier });
    trackingCallback && trackingCallback({ id: 'cui.subtitle.clicked' });
  };

  const isShowButtonCol = find(orderReviewHandleableConfig, ({
    editable,
    deletable,
  }) => {
    return editable || deletable;
  });

  return (
    <div className="checkout-order-view cui-mg-t-60">
      <Grid colGap={0} rowGap={0} className="order-review-title">
        <GridItem span={6} className="order-review-title__main-title">
          <h2 className="second-level-title">
            <Locale id="checkout.lib.components.text.orderReview" />
          </h2>
        </GridItem>
        <GridItem span={6} className="order-review-title__subTitle">
          {orderReviewActionCallback
            ? (<div
              className="link-style"
              onKeyDown={handleKeyboardEvent(handleSubtitleClicked, [ 'Enter' ])}
              onClick={handleSubtitleClicked}>
              <span
                tabIndex="0"
                role="button">
                {orderReviewActionText || <Locale id="checkout.lib.components.text.addAnotherRegistration" /> }
              </span>
            </div>) : null
          }
        </GridItem>
      </Grid>
      <OrderDetailContent
        {...orderInfo}
        orderDescription={orderReviewDescription}
        handleOrderReviewCallback={handleOrderReviewCallback}
        trackingCallback={trackingCallback}
        orderReviewModel={orderReviewModel}
        orderReviewHandleableConfig={orderReviewHandleableConfig}
        isShowOrderAmount={false}
        isShowButtonCol={isShowButtonCol}
        className={classNames({
          'order-review__content': true,
        })}/>
    </div>);
};

OrderReview.propTypes = {
  showOrderReviewSection: bool,
  orderReviewActionText: string,
  orderReviewDescription: string,
  orderReviewHandleableConfig: array,
  orderReviewModel: string,
  orderReviewActionCallback: func,
  handleOrderReviewCallback: func,
  trackingCallback: func,
  orderInfo: object,
};

OrderReview.defaultProps = {
  orderReviewHandleableConfig: [],
  orderInfo: {},
};

export default memo(OrderReview);
